<template>
  <div>两票档案</div>
</template>

<script>
export default {
  name: 'TicketsFiles',
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped></style>
